module.exports = __webpack_public_path__ + "static/media/ptp02.1c3c8e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/etp/ptp02.jpg
// module id = 404
// module chunks = 0